module.exports = __webpack_public_path__ + "img/scooltools--appLoader-leerlijn.66279477.png";